import { useEffect, useRef, useState } from "react";
const COPIED_RESET_DELAY_MS = 2000;
const useCopyToClipboard = () => {
    const [copied, setCopied] = useState(false);
    const resetTimerRef = useRef(null);
    useEffect(() => () => {
        if (resetTimerRef.current) {
            clearTimeout(resetTimerRef.current);
        }
    }, []);
    const handleCopy = () => {
        setCopied(true);
        if (resetTimerRef.current) {
            clearTimeout(resetTimerRef.current);
        }
        resetTimerRef.current = setTimeout(() => setCopied(false), COPIED_RESET_DELAY_MS);
    };
    return { copied, handleCopy };
};
export default useCopyToClipboard;
